import React from 'react'
import Map from '../../../../../../common/components/map'
import _ from 'lodash';
import { format } from '../../../../../../common/services/common.service';

export default function TripBasicInfoComponent({ orderDetails, tripsDetails, getShippingType, ConvertMinutes }: any) {

    const getRandomTextColor = () => {
        const red = Math.floor(Math.random() * 128);
        const green = Math.floor(Math.random() * 128);
        const blue = Math.floor(Math.random() * 128);
        const hexRed = red.toString(16).padStart(2, "0");
        const hexGreen = green.toString(16).padStart(2, "0");
        const hexBlue = blue.toString(16).padStart(2, "0");

        const hexCode = `#${hexRed}${hexGreen}${hexBlue}`;
        return hexCode;
    }

    const originGps = tripsDetails?.fulfillments[0]?.start?.location?.gps;
    const destinationGps = tripsDetails?.fulfillments[0]?.end?.location?.gps;
    const image = require('../../../../../../assets/img/delivery.png')
    const latLongData: any = _.split(originGps, ',');
    return (
        <>

            <div className="min-h-[450px] w-full  flex flex-col justify-between bg-gray-50 mb-8 py-5 border border-gray-200">

                {originGps && <div className="w-full bg-white px-5 text-gray-800">

                    <div className="w-full">
                        <Map
                            lat={latLongData[0]}
                            lng={latLongData[1]}
                            height={'420px'}
                            zoom={15}
                            icon={image}
                            showInfoWindow={false}
                            isRouteDirection={true}
                            originLocation={originGps}
                            destinationLocation={destinationGps}
                        />

                    </div>
                </div>}

                <div className="w-full min-h-full flex justify-between flex-col md:flex-row">
                    {tripsDetails && <div className="px-5 w-1/4 mt-10">
                        <div className="">
                            <h3 className="font-bold text-gray-600 text-xl">Order</h3>
                        </div>
                        <div className="mb-2 text-gray-400">
                            <div><span className="text-gray-500 text-sm">Order ID:</span><span className="text-gray-600 text-sm px-2">{tripsDetails?.ShipmentId}</span></div>
                            <div><span className="text-gray-500 text-sm">Job ID:</span><span className="text-gray-600 text-sm px-2">{tripsDetails?.JobId}</span></div>
                            <div><span className="text-gray-500 text-sm">Transport Agents:</span><span className="text-gray-600 text-sm px-2">{tripsDetails?.fulfillments[0]?.agent?.name}</span></div>
                            <div><span className="text-gray-500 text-sm">vehicle Type:</span><span className="text-gray-600 text-sm px-2">{tripsDetails?.fulfillments[0]?.vehicle?.vehicleType}</span></div>
                            <div><span className="text-gray-500 text-sm">Status:</span><span className="text-gray-600 text-sm px-2">

                            </span>
                                <div
                                    className={`p-2 rounded-full text-white text-center`}
                                    style={{ backgroundColor: getRandomTextColor() }}>
                                    {getShippingType(tripsDetails?.CargoTripsStatusId) || null}
                                </div>

                            </div>
                            <div><span className="text-gray-500 text-sm">Pickup Date/time</span><span className="text-gray-600 text-sm px-2">{format(orderDetails?.ShippedDateUtc)}</span></div>
                            <div><span className="text-gray-500 text-sm">Remaining Time</span><span className="text-gray-600 text-sm px-2">{ConvertMinutes(orderDetails?.RemainingDeliveryTime || 0)}</span></div>
                        </div>

                    </div>}
                    <div className="px-5 w-1/4 mt-10">
                        <div className="mb-2">
                            <h3 className="font-bold text-gray-600 text-xl">Pickup</h3>
                        </div>
                        {tripsDetails?.fulfillments[0]?.start && <div className="mb-2 text-gray-400">
                            <div><span className="text-gray-500 text-sm">Pincode:</span><span className="text-gray-600 text-sm px-2">{tripsDetails?.fulfillments[0]?.start?.location?.address?.area_code}</span></div>
                            <div><span className="text-gray-500 text-sm">Name</span><span className="text-gray-600 text-sm px-2">{tripsDetails?.fulfillments[0]?.start?.location?.address?.name}</span></div>
                            <div><span className="text-gray-500 text-sm break-words">Address:</span><span className="text-gray-600 text-sm px-2">{tripsDetails?.fulfillments[0]?.start?.location?.address?.building} , {tripsDetails?.fulfillments[0]?.start?.location?.address?.locality} ,  {tripsDetails?.fulfillments[0]?.start?.location?.address?.city} , {tripsDetails?.fulfillments[0]?.start?.location?.address?.country} , {tripsDetails?.fulfillments[0]?.start?.location?.address?.state} - {tripsDetails?.fulfillments[0]?.start?.location?.address?.area_code}</span></div>
                            <div><span className="text-gray-500 text-sm">Contact:</span><span className="text-gray-600 text-sm px-2">{tripsDetails?.fulfillments[0]?.start?.contact?.phone}</span></div>
                        </div>}
                    </div>
                    <div className="px-5 w-1/4 mt-10">
                        <div className="mb-2">
                            <h3 className="font-bold text-gray-600 text-xl">Delivery</h3>
                        </div>
                        {tripsDetails?.fulfillments[0]?.end && <div className="mb-2 text-gray-400">
                            <div><span className="text-gray-500 text-sm">Pincode:</span><span className="text-gray-600 text-sm px-2">{tripsDetails?.fulfillments[0]?.end?.location?.address?.area_code}</span></div>
                            <div><span className="text-gray-500 text-sm">Name</span><span className="text-gray-600 text-sm px-2">{tripsDetails?.fulfillments[0]?.end?.location?.address?.name}</span></div>
                            <div><span className="text-gray-500 text-sm break-words">Address:</span><span className="text-gray-600 text-sm px-2">{tripsDetails?.fulfillments[0]?.end?.location?.address?.building} , {tripsDetails?.fulfillments[0]?.end?.location?.address?.locality} ,  {tripsDetails?.fulfillments[0]?.end?.location?.address?.city} , {tripsDetails?.fulfillments[0]?.end?.location?.address?.country} , {tripsDetails?.fulfillments[0]?.end?.location?.address?.state} - {tripsDetails?.fulfillments[0]?.end?.location?.address?.area_code}</span></div>
                            <div><span className="text-gray-500 text-sm">Contact:</span><span className="text-gray-600 text-sm px-2">{tripsDetails?.fulfillments[0]?.end?.contact?.phone}</span></div>
                        </div>}
                    </div>
                    {tripsDetails?.LogisticsTasks?.length && <div className="px-5 w-1/4 mt-10">
                        <div className="mb-2">
                            <h3 className="font-bold text-gray-600 text-xl">Tasks</h3>
                        </div>




                    </div>}

                </div>

            </div>

        </>
    )
}